import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { effect, inject } from "@angular/core";
import { combineLatest, filter, map, of, switchMap, take, tap } from "rxjs";
import { APP_ROUTES } from "@app/core/constants/routes.constants";
import { appCheckInstance$ } from "@angular/fire/app-check";
import { FirebaseAuthService } from "../services/firebase-auth.service";
import { UserService } from "@app/core/services/user.service";


export const nonAuthGuard: CanActivateFn =  () => {
  //const fbAuthService = inject(FirebaseAuthService);
  const authService = inject(AuthService);
  const router = inject(Router);
  console.log("inside nonauth guard...");
//  return authService.userProfile$.pipe(
//     // wait until we actually know the state (not undefined)
//     filter(profile => profile !== undefined),
//     take(1),
//     map(profile => {
//       if (profile && profile !== null) {
//         // ✅ Logged-in user → redirect to dashboard
//         console.log('🔒 User already logged in, redirecting to dashboard');
//         return router.createUrlTree([
//           APP_ROUTES.WORKSPACE.ROOT,
//           APP_ROUTES.WORKSPACE.DASHBOARD
//         ]);
//       }

//       // 🚪 No profile → allow access to guest routes
//       return true;
//     })
//   ); 
 
   return authService.userProfile$.pipe(
    filter(p => p !== undefined),
    take(1),
    map(p => (p ? router.createUrlTree([APP_ROUTES.WORKSPACE.ROOT,APP_ROUTES.WORKSPACE.DASHBOARD]) : true))
  );
};